import React from "react";
import { Route, Switch } from "react-router-dom";
import asyncComponent from "util/asyncComponent";

const Admin = ({ match }) => (
  <div className="app-wrapper">
    <Switch>
      <Route
        path={`${match.url}/add`}
        component={asyncComponent(() => import("./routes/AddAdmin"))}
      />
      <Route
        path={`${match.url}/list`}
        component={asyncComponent(() => import("./routes/AdminList"))}
      />
    </Switch>
  </div>
);

export default Admin;
